export default {
  LoginFailure: 'Login Failure, Please Try Again!',
  LoginSuccess: 'Login Success!',
  UserPasswordError: 'User Name or Password Error!',
  GeetestCaptchaError: 'Please Wait for Geetest Verification!',
  ValidateCodeError: 'Slide Verification Error',
  UserNotExist: 'User Not Exist',
  UserNameOrPasswordNull: 'User/Password Must Be Filled',
  IpBlackList: 'Sorry, Your IP Has Been Added to the System Blacklist',
  UserNameRemoved: 'Sorry, Your Account Has Been Deleted',
  UserNameStop: 'User Has Been Disabled, Please Contact the Administrator',
  PassWordErrorMoreLock: 'Password Error 5 Times, Account Locked 10 Minutes',
  GoogleVerifyError: 'Google Verification Code Error',
  VerificationCodeNull: 'Verification Code Must Be Filled',
  VerificationCodeErrorOrExpired: 'Verification Code Error or Expired',
  VerificationCodeSendFrequently: 'Verification Code Send Frequency Too High',
  GoogleBindError: 'Google Authenticator Binding Failed',
  VerificationCodeSendError: 'Email Verification Code Sending Exception',
  SendEmailParamsNotNull: 'Email Verification Code Sending Parameters Cannot Be Empty',
  UserNotLogin: 'User Not Login',
  SendEmailError: 'Send Email Error',
  USER_NOT_AUTHORIZED: 'User Not Authorized',
  BdUserInfoInsertError: 'Bd User Info Insert Error',
  UidExist: 'Uid Exist',
  EmailExist: 'Email Exist',
  EmailNotExist: 'Email Not Exist',
  BdStatusJob: 'Bd Status Job',
  BDExistJunior: 'Bd Exist Junior',
  GoogleVerifyRemoveError: 'Google Verify Remove Error',
  DataExist: 'Data Exist',
  DataNotExist: 'Data Not Exist',
  NotDirect: 'Not Direct',
  InvitationUpdateError: 'Invitation Update Error',
  AgentRoleIsExist: 'Agent Role Is Exist',
  NoSelectSymbol: 'No Select Symbol',
  LevelSymbolError: 'Level Symbol Error',
  LevelSymbolMaxError: 'Level Symbol Max Error',
  OnlyModifySelf: 'Only Modify Self',
  OnlyDeleteSelf: 'Only Delete Self',
  CommissionUsed: 'Commission Used',
  UserEmailNotExist: 'User Email Not Exist',
  UserIsPartner: 'User Is Partner',
  RoleTypeNotSameWithPid: 'Role Type Not Same With Pid',
  PartnerExist: 'User Is Partner',
  RoleTypeNotSame: 'Role Type Not Same',
  LevelSymbolTotalMaxError: 'The sum of rebate configuration percentages cannot equal or exceed 100',
  LengthError: 'Length does not meet requirements',
  NOT_INNER_DOMAIN: 'Admin accounts please use internal domain to login and access',
  ExistPid: 'The user has an upper level and is not allowed to be set as BD',
  LevelSymbolGapError: 'The rebate ratio of the lower level must be less than the rebate ratio of the upper level',
};
